{
	"name": "@whop/cli",
	"version": "0.18.3",
	"description": "The Whop CLI — build and manage Whop apps from your terminal. Human and agent friendly.",
	"keywords": [
		"agent",
		"apps",
		"cli",
		"developer",
		"whop"
	],
	"homepage": "https://whop.com/developers/",
	"bugs": "https://github.com/whopio/whop-public-cli/issues",
	"license": "MIT",
	"repository": {
		"type": "git",
		"url": "https://github.com/whopio/whop-monorepo",
		"directory": "developer-platform/packages/cli"
	},
	"bin": {
		"whop": "dist/index.js",
		"whop-cli": "dist/index.js"
	},
	"files": [
		"dist",
		"skills"
	],
	"type": "module",
	"exports": {
		".": "./dist/index.js",
		"./vite": {
			"types": "./dist/vite.d.ts",
			"import": "./dist/vite.js"
		}
	},
	"publishConfig": {
		"access": "public"
	},
	"scripts": {
		"build": "pnpm sync-spec && pnpm run clean && tsup",
		"build:binary": "tsx scripts/build-binary.ts",
		"clean": "rm -rf dist",
		"dev": "pnpm sync-spec && tsx src/index.ts",
		"start": "node dist/index.js",
		"check-types": "pnpm sync-spec && tsc --noEmit",
		"lint": "oxlint .",
		"lint:fix": "oxlint --fix --fix-suggestions && oxfmt",
		"ci:lint": "oxlint -f github .",
		"format": "oxfmt",
		"sync-spec": "tsx scripts/sync-spec.ts && oxfmt src/api/native-spec.json src/api/groups.json src/api/apps-spec.json src/api/files-spec.json src/api/shipped-skills.json",
		"test": "tsx --test scripts/*.test.ts"
	},
	"dependencies": {
		"@clack/prompts": "^1.5.1",
		"@napi-rs/keyring": "^1.3.0",
		"chalk": "5.4.1",
		"yaml": "2.8.0"
	},
	"devDependencies": {
		"@types/node": "25.3.5",
		"fflate": "0.8.2",
		"incur": "github:whopio/incur#973bd1a868a8ec8f59d05fc3f85555045b183613",
		"oxfmt": "0.42.0",
		"tsup": "8.5.0",
		"tsx": "4.19.4",
		"typescript": "5.9.3",
		"vite": "^8.0.0"
	},
	"engines": {
		"node": ">=22"
	},
	"packageManager": "pnpm@10.23.0"
}
